import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Body from './Components/Body';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
    <Navbar />
    <Home />
    <Body />
    <Footer />
    </div>
  );
}

export default App;
